module.exports = __webpack_public_path__ + "assets/images/project/laos-desktop.jpg?v=adf07a02";